import React from "react";

import { HeroImg, StyledContainer, HeroText } from "./styles";


export default function Hero() {
  return (
    <StyledContainer id="hero">
      <HeroImg />
      <HeroText> DEVELOPER AND DESIGNER</HeroText>
    </StyledContainer>
  );
}
